<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="top-box">
      <div class="content-positioning">
        <div class="title-1">AI 外呼</div>
        <div class="title-2">智能客服全场景覆盖，降本增效提质</div>
        <div class="btn-group">
          <div class="btn-primary" @click="openContactUs">申请试用</div>
          <div class="btn-secondary">查看案例</div>
        </div>
      </div>
    </div>

    <!-- 核心功能 -->
    <div class="capability-section">
      <div class="section-title">核心功能</div>
      <div class="capability-grid">
        <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
          <div class="capability-icon">{{ item.icon }}</div>
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 应用场景 -->
    <div class="scenario-section">
      <div class="section-title">应用场景</div>
      <div class="scenario-grid">
        <div class="scenario-card" v-for="(item, index) in scenarioList" :key="index">
          <div class="scenario-icon">{{ item.icon }}</div>
          <div class="scenario-title">{{ item.name }}</div>
          <div class="scenario-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.aiCall,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: '📞', name: '智能外呼', desc: 'AI 自动拨号，智能语音交互' },
        { icon: '🤖', name: '智能客服', desc: '7×24 小时在线服务' },
        { icon: '📊', name: '通话分析', desc: '实时分析通话内容' },
        { icon: '💬', name: '工单管理', desc: '自动生成工单，流转处理' }
      ],
      scenarioList: [
        { icon: '🏢', name: '客户回访', desc: '批量客户回访，提高效率' },
        { icon: '📝', name: '通知提醒', desc: '账单、活动等智能通知' },
        { icon: '🎯', name: '营销推广', desc: '精准营销，提升转化' },
        { icon: '📈', name: '满意度调查', desc: '自动收集客户反馈' }
      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'AI 外呼')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-positioning {
  max-width: 800px;
  text-align: center;
  color: #fff;

  .title-1 {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .title-2 {
    font-size: 20px;
    opacity: 0.9;
    margin-bottom: 40px;
  }

  .btn-group {
    display: flex;
    gap: 20px;
    justify-content: center;

    .btn-primary, .btn-secondary {
      padding: 14px 40px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      transition: all 0.3s;

      &:hover {
        transform: translateY(-2px);
      }
    }

    .btn-primary {
      background: #fff;
      color: #667eea;
      font-weight: bold;
    }

    .btn-secondary {
      background: transparent;
      color: #fff;
      border: 2px solid #fff;
    }
  }
}

.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
  color: #222;
}

.capability-section, .scenario-section {
  padding: 80px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.capability-grid, .scenario-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

.capability-card, .scenario-card {
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-8px);
  }
}

.capability-icon, .scenario-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.capability-name, .scenario-title {
  font-size: 20px;
  font-weight: bold;
  color: #222;
  margin-bottom: 12px;
}

.capability-desc, .scenario-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
</style>
